<template>
  <div>
    <v-snackbar
      :timeout="2000"
      :value="true"
      absolute
      top
      color="red"
      right
      text
      v-if="appear"
    >
      Password not match
    </v-snackbar>
    <v-dialog
      v-model="staffModal"
      max-width="500px"
      :persistent="true"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Record new Staff</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="names"
                  label="Names"
                  name="Names"
                  v-validate="'required'"
                ></v-text-field>
                <span style="color: red;"
                  v-show="errors.has('Names')" v-if="showError">{{ errors.first('Names') }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="email"
                  label="Email"
                  name="Email"
                  v-validate="'required|email'"
                ></v-text-field>
                <span style="color: red;"
                  v-show="errors.has('Email')" v-if="showError">{{ errors.first('Email') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="phone"
                  label="Phone"
                  name="Phone"
                  v-validate="'required|numeric'"
                ></v-text-field>
                <span style="color: red;"
                  v-show="errors.has('Phone')" v-if="showError">{{ errors.first('Phone') }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-text-field
                  v-model="address"
                  label="Address"
                  name="Address"
                  v-validate="'required'"
                ></v-text-field>
                <span style="color: red;"
                  v-show="errors.has('Address')" v-if="showError">{{ errors.first('Address') }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-select
                  v-model="privilege"
                  label="Choose privilege"
                  name="Privilege"
                  v-validate="'required'"
                  :items="posts"
                ></v-select>
                <span style="color: red;"
                  v-show="errors.has('Privilege')" v-if="showError">{{ errors.first('Privilege') }}</span>
              </v-col>
              <v-col
                cols="6"
                sm="12"
                md="6"
              >
                <v-select
                  v-model="groupId"
                  label="Assign Privilege group"
                  name="Group"
                  v-validate="'required'"
                  :items="groups"
                ></v-select>
                <span style="color: red;"
                  v-show="errors.has('Group')" v-if="showError">{{ errors.first('Group') }}</span>
              </v-col>
              <v-col
                cols="12"
                sm="12"
                md="12"
              >
                <v-select
                  v-model="country"
                  label="Choose country"
                  name="Country"
                  v-validate="'required'"
                  :items="countries"
                ></v-select>
                <span style="color: red;"
                  v-show="errors.has('Country')" v-if="showError">{{ errors.first('Country') }}</span>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="close"
          >
            Cancel
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="validate"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'NewStaff',

  props: {
    staffModal: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      privilege: null,
      address: '',
      names: '',
      email: '',
      phone: '',
      country: null,
      password: '',
      confirmpassword: '',
      showError: true,
      appear: false,
      posts: [],
      groups: [],
      groupId: null,
      countries: ['Afghanistan', 'Åland Islands', 'Albania', 'Algeria', 'American Samoa', 'Andorra', 'Angola', 'Anguilla', 'Antarctica', 'Antigua And Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia, Plurinational State Of', 'Bonaire, Sint Eustatius And Saba', 'Bosnia And Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo DRC', 'Cook Islands', 'Costa Rica', "Côte D'ivoire", 'Croatia', 'Cuba', 'Curaçao', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-bissau', 'Guyana', 'Haiti', 'Heard Island And Mcdonald Islands', 'Holy See (vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Isle Of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', "Korea, Democratic People's Republic Of", 'Korea, Republic Of', 'Kuwait', 'Kyrgyzstan', "Lao People's Democratic Republic", 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, The Former Yugoslav Republic Of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States Of', 'Moldova, Republic Of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestine, State Of', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Réunion', 'Romania', 'Russian Federation', 'Rwanda', 'Saint Barthélemy', 'Saint Helena, Ascension And Tristan Da Cunha', 'Saint Kitts And Nevis', 'Saint Lucia', 'Saint Martin (french Part)', 'Saint Pierre And Miquelon', 'Saint Vincent And The Grenadines', 'Samoa', 'San Marino', 'Sao Tome And Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten (dutch Part)', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia And The South Sandwich Islands', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard And Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province Of China', 'Tajikistan', 'Tanzania, United Republic Of', 'Thailand', 'Timor-leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad And Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks And Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela, Bolivarian Republic Of', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.s.', 'Wallis And Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
    }
  },
  created () {
    this.fetchSelectedPosts()
    this.fetchGroups()
  },
  methods: {
    close () {
      this.privilege = null
      this.address = ''
      this.names = ''
      this.email = ''
      this.phone = ''
      this.country = null
      this.valid = false
      this.showError = false
      this.groupId = ''
      this.$emit('offModal', false)
    },
    async validate () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.save()
        } else {
          // form have errors
        }
      })
    },
    async save () {
      if (this.names === '' || this.privilege === '' || this.country === '' || this.phone === '' || this.phone === '' || this.address === '' || this.email === '') {
        this.validate()
      } else if (this.password !== this.confirmpassword) {
        this.appear = true
        setTimeout(() => {
          this.confirmpassword = ''
        }, 2000)
      } else {
        if (localStorage.getItem('logged_user')) {
          this.logger = JSON.parse(localStorage.getItem('logged_user'))
        }
        this.header = this.logger.accessToken
        const data = {
          names: this.names,
          privilege: this.privilege,
          country: this.country,
          phone: this.phone,
          address: this.address,
          email: this.email,
          id: this.id,
          group: this.groupId,
        }
        try {
          const res = await this.axios({
            url: 'manipulate_staff',
            method: 'post',
            data: data,
            headers: {
              Authorization: 'Bearer ' + this.header,
            },
          })
          if (res.status === 200) {
            this.$emit('getResponse', res.data)
            this.names = ''
            this.email = ''
            this.phone = ''
            this.privilege = ''
            this.address = ''
            this.close()
          } else {
            alert('Data not saved')
          }
        } catch (e) {
          if (e.response && e.response.status === 401) {
            this.$router.push({ name: 'login-page' })
          } else if (e.response && e.response.status === 400) {
            alert(e.response.data.messages)
          } else {
            console.log(e)
          }
        }
      }
    },
    async fetchSelectedPosts () {
      if (localStorage.getItem('logged_user')) {
        this.logger = JSON.parse(localStorage.getItem('logged_user'))
      }
      this.header = this.logger.accessToken
      try {
        const res = await this.axios({
          url: 'get_selected_post',
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + this.header,
          },
        })
        if (res.status === 200) {
          this.posts = res.data
          console.log(res.data)
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$router.push({ name: 'login-page' })
        } else {
          console.log(error)
        }
      }
    },
    async fetchGroups () {
      if (localStorage.getItem('logged_user')) {
        this.logger = JSON.parse(localStorage.getItem('logged_user'))
      }
      this.header = this.logger.accessToken
      try {
        const res = await this.axios({
          url: 'get_groups',
          method: 'get',
          headers: {
            Authorization: 'Bearer ' + this.header,
          },
        })
        if (res.status === 200) {
          this.groups = res.data
          console.log(res.data)
        }
      } catch (error) {
        if (error.response && error.response.status === 401) {
          this.$router.push({ name: 'login-page' })
        } else {
          console.log(error)
        }
      }
    },
  },
}
</script>

<style scoped>

</style>
